
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class PuAccordionStateless extends Vue {
  @Prop({ type: Boolean, default: false })
  value!: boolean

  @Prop({ type: String, default: 'slide' })
  transitionName!: string

  index: number

  created() {
    this.index = Date.now()
  }
}
